import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { config } from 'lib-shared-backend-config';
import { Suspense } from 'react';

import { useNotifications } from 'hooks/useNotifications';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { KnowledgeErrorPlaceholder } from './components/errorPlaceholder';
import { KnowledgeLoading } from './components/loading';
import { RemoteKnowledgeManagementRoutes } from './components/remotes';

export const KnowledgeManagementRoutes = (): JSX.Element => {
  const notify = useNotifications();
  const flags = useFeatureFlag(['knowledge-articles-ai-auto-translations']);

  return (
    <ErrorBoundary fallback={<KnowledgeErrorPlaceholder />}>
      <Suspense fallback={<KnowledgeLoading />}>
        <RemoteKnowledgeManagementRoutes
          notify={notify}
          environment={config.environment}
          featureFlags={{
            aiAutoTranslation: flags.knowledgeArticlesAiAutoTranslations,
          }}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
